import { FULFILLMENT_QUEUE_GROUPS, queueGroupCount } from '../../utils/ordersOperationsPresentation';

export default function FulfillmentQueueTabs({ activeGroup, counts, onChange }) {
  return (
    <div className="flex gap-2 overflow-x-auto overscroll-x-contain pb-1" aria-label="Fulfillment queues">
      {FULFILLMENT_QUEUE_GROUPS.map(group => {
        const active = group.key === activeGroup;
        const count = queueGroupCount(counts, group.key);
        return (
          <button
            key={group.key}
            type="button"
            onClick={() => onChange(group.key)}
            aria-pressed={active}
            className={[
              'min-h-10 shrink-0 rounded-lg border px-3 py-2 text-xs font-semibold transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus',
              active
                ? 'border-neutral-900 bg-neutral-900 text-white dark:border-neutral-100 dark:bg-neutral-100 dark:text-neutral-900'
                : 'border-neutral-200 bg-white text-neutral-600 hover:border-neutral-300 hover:bg-neutral-50 dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-300 dark:hover:bg-neutral-800',
            ].join(' ')}
          >
            {group.label} <span className={active ? 'text-white/80 dark:text-neutral-900/70' : 'text-neutral-400'}>{count}</span>
          </button>
        );
      })}
    </div>
  );
}
